<script setup lang="ts">
import { syncRef, useTimeoutFn, whenever } from "@vueuse/core";
import SimpleButton from "ls/components/simple-button/SimpleButton.vue";
import { SimpleTooltip } from "ls/components/simple-tooltip";
import { computed, ref } from "vue";

const emits = defineEmits<{
  actualizeLink: [];
}>();

const showUpdated = defineModel<boolean>("showUpdated", { required: true });
const tooltipOpen = ref(false);
syncRef(showUpdated, tooltipOpen, {
  direction: "ltr",
  immediate: false,
});

const { start: hideUpdated } = useTimeoutFn(() => {
  showUpdated.value = false;
}, 1000);

whenever(showUpdated, hideUpdated);

const tooltipContent = computed(() => {
  return showUpdated.value ? "Updated" : "Update embed link to the current configuration";
});

function handleUpdateOpen(value: boolean) {
  if (showUpdated.value) return;
  tooltipOpen.value = value;
}
</script>

<template>
  <SimpleTooltip
    :open="tooltipOpen"
    :content="tooltipContent"
    side="top"
    @update:open="handleUpdateOpen"
  >
    <SimpleButton
      variant="secondary"
      @click.stop="emits('actualizeLink')"
    >
      Update link
    </SimpleButton>
  </SimpleTooltip>
</template>
